import React from 'react';
import { useLayoutMode } from './Layout';
import PagingRealistic from './PagingRealistic';

export default function ConditionalPagination() {
  const { layoutMode } = useLayoutMode();

  if (layoutMode === 'map') {
    return null;
  }

  return <PagingRealistic />;
}
